import React from 'react';
import { LymphoriaXPage } from './pages/LymphoriaXPage';
export function App() {
  return <LymphoriaXPage data-id="element-0" />;
}